import React, { useEffect, useState } from 'react';
import { Button, Dialog, DialogContent, DialogTitle, TextField, Grid, DialogActions } from '@mui/material';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { DropzoneArea } from 'mui-file-dropzone';
import { v4 } from 'uuid';
export function EditVendedorDialog({ onClose, vendedor, title, ...props }) {
    const [image, setImage] = useState(null);
    const [newImage, setNewImage] = useState(null);
    const validationSchema = yup.object({
        contacto: yup
            .string()
            .matches(/^[0-9]+$/, 'O contacto deve conter apenas números')
            .min(9, 'O contacto deve ter pelo menos 9 caracteres')
            .max(15, 'O contacto deve ter no máximo 15 caracteres')
            .nullable(),
        email: yup.string().email('Email inválido'),
        imagem: yup.string().nullable()
    });
    const formik = useFormik({
        initialValues: {
            contacto: vendedor.Funcionario.telemovel,
            email: vendedor.Funcionario.email,
            imagem: vendedor.imagem
        },
        validationSchema,
        validateOnChange: false,
        onSubmit: values => {
            if (newImage && !newImage.dummy) {
                // Se houver uma nova imagem, atualiza os valores corretamente
                values.file = newImage.file;
                values.imagem = newImage.file.name;
            }
            else {
                // Se a imagem não foi alterada, mantém a imagem original
                values.file = null;
                values.imagem = vendedor.imagem || null;
            }
            onClose(values);
        }
    });
    useEffect(() => {
        if (vendedor.imagem) {
            let imageUrl = `/api/Upload/crm/download/${vendedor.imagem}`;
            setImage(imageUrl); // Define a imagem existente
        }
    }, []);
    return (<Dialog {...props} fullWidth maxWidth='md' onClose={() => onClose(null)}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <TextField fullWidth id='contacto' label='Contacto *' color='info' size='small' value={formik.values.contacto} onChange={formik.handleChange} onBlur={formik.handleBlur} // Ativa o estado "touched"
     error={formik.touched.contacto && Boolean(formik.errors.contacto)} helperText={formik.touched.contacto && formik.errors.contacto}/>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <TextField fullWidth id='email' label='Email *' color='info' size='small' disabled value={formik.values.email}/>
          </Grid>
          <Grid item xs={12}>
            <DropzoneArea acceptedFiles={['image/jpeg', 'image/png']} initialFiles={image ? [image] : []} // Usa a imagem carregada da pessoa ou deixa vazio
     onChange={files => {
            if (vendedor.imagem !== files[0]?.name) {
                if (files.length > 0) {
                    let t = files.pop();
                    // Usa o mesmo nome da imagem antiga, se existir
                    let fileName = vendedor.imagem ? vendedor.imagem : `${v4()}.${t.name.split('.').pop()}`;
                    let f = new File([t], fileName, { type: t.type });
                    setNewImage({ file: f, dummy: false });
                    setImage(URL.createObjectURL(f));
                    formik.setFieldValue('imagem', fileName);
                }
                else {
                    setNewImage(null);
                    setImage(null);
                }
            }
        }} showFileNames={false} showAlerts={false} showPreviewsInDropzone={true} 
    //useChipsForPreview={true}
    dropzoneText='Arraste e solte a imagem aqui ou clique' filesLimit={1}/>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions sx={{ mt: 1 }}>
        <Button onClick={() => {
            onClose();
        }}>
          Cancelar
        </Button>
        <Button onClick={() => {
            formik.handleSubmit();
        }} variant='contained'>
          OK
        </Button>
      </DialogActions>
    </Dialog>);
}
